<template>
  <div class="whatsapp-phone-field">
    <div class="whatsapp-phone-field__row">
      <v-text-field
        outlined
        color="#3487ac"
        class="whatsapp-phone-field__country"
        prefix="+"
        :value="countryCode"
        required
        @input="onCountryCodeInput"
        @keydown.native="onCountryCodeKeydown"
        type="tel"
        inputmode="numeric"
        autocomplete="tel-country-code"
        hide-details
      />
      <v-text-field
        outlined
        color="#3487ac"
        class="whatsapp-phone-field__input"
        :label="label"
        :name="inputName"
        :value="nationalDigits"
        :error-messages="errorMessages"
        required
        @input="onNationalInput"
        @keydown.native="onNationalKeydown"
        type="tel"
        inputmode="numeric"
        autocomplete="tel-national"
        :hide-details="!(errorMessages && errorMessages.length)"
      />
    </div>
  </div>
</template>

<script>
const MAX_COUNTRY_CODE_DIGITS = 3;
const MAX_NATIONAL_DIGITS = 14;

export default {
  name: "WhatsAppPhoneField",
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    countryLabel: {
      type: String,
      default: "Country code",
    },
    inputName: {
      type: String,
      default: "contact[whatsapp]",
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      countryCode: "",
      nationalDigits: "",
    };
  },
  watch: {
    value(v) {
      if (!v) {
        this.countryCode = "";
        this.nationalDigits = "";
      }
    },
  },
  methods: {
    guardDigitsKeydown(e, currentDigits, maxLen) {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      const nav = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
      ];
      if (nav.includes(e.key)) return;
      if (e.key.length === 1 && /\d/.test(e.key)) {
        const el = e.target;
        const hasSelection =
          el &&
          typeof el.selectionStart === "number" &&
          el.selectionStart !== el.selectionEnd;
        if (!hasSelection && currentDigits.length >= maxLen) {
          e.preventDefault();
        }
        return;
      }
      if (e.key.length === 1) {
        e.preventDefault();
      }
    },
    onCountryCodeKeydown(e) {
      this.guardDigitsKeydown(e, this.countryCode, MAX_COUNTRY_CODE_DIGITS);
    },
    onNationalKeydown(e) {
      this.guardDigitsKeydown(e, this.nationalDigits, MAX_NATIONAL_DIGITS);
    },
    onCountryCodeInput(val) {
      this.countryCode = String(val || "")
        .replace(/\D/g, "")
        .slice(0, MAX_COUNTRY_CODE_DIGITS);
      this.emitValue();
    },
    onNationalInput(val) {
      this.nationalDigits = String(val || "")
        .replace(/\D/g, "")
        .slice(0, MAX_NATIONAL_DIGITS);
      this.emitValue();
    },
    emitValue() {
      if (this.countryCode && this.nationalDigits) {
        this.$emit("input", "+" + this.countryCode + this.nationalDigits);
      } else {
        this.$emit("input", "");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.whatsapp-phone-field__row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  width: 100%;
}

.whatsapp-phone-field__country {
  flex: 0 0 104px;
  max-width: 104px;

  ::v-deep .v-input__slot {
    padding-left: 8px !important;
    padding-right: 8px !important;
    min-height: 56px;
    align-items: center;
  }

  ::v-deep .v-label {
    font-size: 11px;
    max-width: calc(100% - 24px);
  }
}

.whatsapp-phone-field__input {
  flex: 1;
  min-width: 0;
}
</style>
